import { css } from "@emotion/react";
import { styled } from "../theme";
export const Tag = styled.span `
  display: inline-block;
  padding: 4px 12px 3px 12px;
  min-width: 90px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 500;
  color: ${({ fontColor }) => fontColor};
  text-align: center;
  box-sizing: border-box;
  background-color: ${({ theme, color }) => theme.color[color]};
  border: 1px solid transparent;

  ${({ color, outline, theme }) => outline &&
    css `
      border: 1px solid ${theme.color[color]};
      background-color: transparent;
      color: ${theme.color[color]};
    `}
`;
Tag.defaultProps = {
    color: "gray100",
    outline: false,
    fontColor: "white",
};
